/* eslint-disable */
import styled from 'styled-components';
import OnMountHomeScroll from 'hoc/OnMountHomeScroll';

const G90HomePageTemplate = styled.div`
    min-height: calc(100vh - 100px);
    position: relative;
    background-color: ${props => props.theme.colors.shakespeare}; 
`;

export default OnMountHomeScroll()(G90HomePageTemplate);



// WEBPACK FOOTER //
// ./src/components/templates/G90HomePage.js